import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 20px;

  span.MuiSkeleton-circular {
    flex-shrink: 0;
    margin-right: 10px;
  }

  span.MuiSkeleton-text {
    flex: 1;
  }
`;

export default Container;
